<template>
  <app-content class="h-panel">
    <div class="flex justify-between m-16px pt-16px">
      <DropdownCustom ref="paramsDropdown" button class="h-btn-primary" trigger="click" :disabled="subjectIds">
        <div v-if="params.start!==params.end">{{ fqFormat(params.start) }} 至 {{ fqFormat(params.end) }}</div>
        <div v-else>{{ fqFormat(params.start) }}</div>
        <template #content>
          <Form style="padding: 10px;width: 400px">
            <FormItem class="!pb-5px" label="会计期间">
              <div class="flex items-center">
                <Select @change="changeStart" v-model="params.start" :deletable="false" filterable :datas="checkoutSelect"/>
                <span class="mx-8px">至</span>
                <Select @change="changeEnd" v-model="params.end" :deletable="false" filterable :datas="checkoutSelect"/>
              </div>
            </FormItem>
            <FormItem class="!pb-5px" label="起始科目">
              <Select :datas="subjectList" :filter="sfilter" keyName="code" titleName="fullName" v-model="params.subjectStart">
                <template #show="{value}">
                  {{ value.code }} {{ value.fullName }}
                </template>
                <template #item="{item}">
                  {{ item.code }} {{ item.fullName }}
                </template>
              </Select>
            </FormItem>
            <FormItem class="!pb-5px" label="结束科目">
              <Select :datas="subjectList" :filter="sfilter" keyName="code" titleName="fullName" v-model="params.subjectEnd">
                <template #show="{value}">
                  {{ value.code }} {{ value.fullName }}
                </template>
                <template #item="{item}">
                  {{ item.code }} {{ item.fullName }}
                </template>
              </Select>
            </FormItem>
            <FormItem class="!pb-5px" label="科目级别">
              <div class="flex items-center">
                <Select v-model="params.levelStart" :deletable="false" filterable :datas="[1,2,3,4]"/>
                <span class="mx-8px">至</span>
                <Select v-model="params.levelEnd" :deletable="false" filterable :datas="[1,2,3,4]"/>
              </div>
            </FormItem>
            <FormItem class="!pb-5px">
              <!-- <Button color="primary" @click="loadSubject();" :loading="loading">确定</Button> -->
              <Button color="primary" @click="submitQuery();loadSubject();" :loading="loading">确定</Button>
              <Button @click="this.$refs.paramsDropdown.hide()">取消</Button>
              <Button @click="resetForm">重置</Button>
            </FormItem>
          </Form>
        </template>
      </DropdownCustom>
      <div class="float-right flex items-center">
        <!-- 取消普通明细账数量显示 -->
        <!-- <Checkbox class="mr-16px" :disabled="numPriceDisabled" v-model="showNumPrice">显示数量金额</Checkbox> -->
        <vxe-button @click="exportData" icon="fa fa-download" content="导出"/>
        <vxe-button v-if="!subjectIds" @click="outModel=true;valueRadio='';isReadyPrints=true" icon="fa fa-print" content="连续导出"/>
        <vxe-button @click="printData" icon="fa fa-print" content="打印"/>
        <!-- jxd连续打印账簿 -->
        <!-- <vxe-button v-print="printAcc" icon="fa fa-print" content="连续打印"/>@click="openedQQ=true" -->
        <vxe-button v-if="!subjectIds" @click="printModel=true;valueRadio='';isReadyPrints=true" icon="fa fa-print" content="连续打印"/>
        <Modal v-model="outModel" v-bind="paramsStyle">
          <div style="
            font-size: 16px;
            border-bottom: 1px solid;
            padding: 6px;">请选择要打印的明细账科目</div>
          <div>
            <div><Radio @change="changeRadio('out')" :value='paramRadioOut[0].key' v-model="valueRadioOut">导出全部科目</Radio></div>
            <div><Radio @change="changeRadio('out')" :value='paramRadioOut[1].key' v-model="valueRadioOut">导出顶级科目</Radio></div>
          </div>
          <div style="display: flex;
            justify-content: right;
            border-top: 1px solid;
            padding: 6px;">
            <div style="margin-top: 6px;">
              <vxe-button @click="outModel=false" icon="vxe-icon-undo" content="取消"/>
              <vxe-button @click="outModel=false;outStart()" icon="vxe-icon-print" :loading="isReadyOut" content="开始导出"/>
            </div>
          </div>
        </Modal>
        <!-- jxd连续打印弹出 -->
        <Modal v-model="printModel" v-bind="paramsStyle">
          <div style="
            font-size: 16px;
            border-bottom: 1px solid;
            padding: 6px;">请选择要打印的明细账科目</div>
          <div>
            <div><Radio @change="changeRadio" :value='paramRadio[0].key' v-model="valueRadio">打印全部科目</Radio></div>
            <div><Radio @change="changeRadio" :value='paramRadio[1].key' v-model="valueRadio">打印顶级科目</Radio></div>
          </div>
          <div style="display: flex;
            justify-content: right;
            border-top: 1px solid;
            padding: 6px;">
            <div style="margin-top: 6px;">
              <vxe-button @click="printModel=false" icon="vxe-icon-undo" content="取消"/>
              <vxe-button v-print="printAcc" @click="printModel=false" icon="vxe-icon-print" :loading="isReadyPrints" content="开始打印"/>
            </div>
          </div>
        </Modal>
      </div>
    </div>
    <div class="text-center mb-16px font-bold text-20px">{{ subject ? subject.name : "" }} {{ title }} 明细账</div>
    <div class="h-panel-body flex ">
      <div style="overflow-x: auto;flex: 1;height: calc(100vh - 290px)" class="mr-8px">
        <vxe-table ref="xTable" :data="datalist" height="auto" border stripe>
          <vxe-column title="日期" field="voucherDate" width="11%" align="center"/>
          <vxe-column title="凭证字号" field="voucherId" width="8%" align="center">
            <template #default="{row}">
              <router-link class="text-hover primary-color" @success="loadList()" width="1120px"
                           v-if="row.voucherId"
                           :to="{name:'VoucherForm',params:{voucherId:row.voucherId}}">
                {{ row.word }}-{{ row.code }}
              </router-link>
            </template>
          </vxe-column>
          <vxe-column title="科目" field="subjectName" width="14%"/>
          <vxe-column title="摘要" field="summary" width="20%"/>
          <vxe-column title="借方" field="debitAmount" width="14%" align="right" formatter="toMoney"/>
          <vxe-column title="贷方" field="creditAmount" width="14%" align="right" formatter="toMoney"/>
          <vxe-column title="方向" field="balanceDirection" align="center" width="5%"/>
          <vxe-column title="余额" field="balance" width="14%" align="right" formatter="toMoney"/>
        </vxe-table>
      </div>
      
      <div style="overflow: scroll;max-height: calc(100vh - 290px);width: 212px;" v-if="!subjectIds">
        <Tree v-model="subjectId" @select="subjectSelect" :option="param" ref="subject" filterable selectOnClick className="h-tree-theme-row-selected"></Tree>
      </div>
    </div>
    <!-- 连续打印原生模版jxd -->
    <div style="width: 0;height: 0; overflow: hidden;">
      <div id="printMe">
        <div v-for="(item,index) in allData" style="width:100%;page-break-before:always;margin:0 auto">
          <p style="font-size: 16px;font-weight: bold;">{{ item.name }}明细账</p>
          <div style="display:flex;justify-content: space-between;height:22px;line-height:22px">
              <span>科目：{{item.name}}</span>
              <span> {{item.date}} </span>
              <span> 单位：元 </span>
          </div>
          <table style="margin-bottom:4px;margin-top: 4px;border-collapse:collapse;width:100%;">
            <thead style="font-weight:bold;">
                <tr>
                    <th style="height:36px;border:1px solid;padding:2px;width:75px;font-size: 14px;">日期</th>
                    <th style="height:36px;border:1px solid;padding:2px;width:45px;font-size: 14px;">凭证字号</th>
                    <th style="height:36px;border:1px solid;padding:2px;width:145px;font-size: 14px;">科目</th>
                    <th style="height:36px;border:1px solid;padding:2px;width:165px;font-size: 14px;">摘要</th>
                    <th style="height:36px;border:1px solid;padding:2px;width:87px;font-size: 14px;">借方</th>
                    <th style="height:36px;border:1px solid;padding:2px;width:87px;font-size: 14px;">贷方</th>
                    <th style="height:36px;border:1px solid;padding:2px;width:35px;font-size: 14px;">方向</th>
                    <th style="height:36px;border:1px solid;padding:2px;width:87px;font-size: 14px;">余额</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(items,index) in item.data">
                    <td style="height:30px;text-align: center; font-size: 12px;border:1px solid;padding:2px;width:75px;word-wrap: break-word;white-space: normal;overflow-wrap: break-word;">{{ items.voucherDate }}</td>
                    <td style="height:30px;text-align: center;font-size: 12px;border:1px solid;padding:2px;width:45px;word-wrap: break-word;white-space: normal;overflow-wrap: break-word;">
                      <span v-if="items.voucherId">{{ items.word }} - {{ items.code }}</span>
                    </td>
                    <td style="height:30px;font-size: 12px;border:1px solid;padding:2px;width:145px;word-wrap: break-word;white-space: normal;overflow-wrap: break-word;">{{ items.subjectName }}</td>
                    <!-- jxd word-break: break-all;让纯数字也能换行 -->
                    <td style="height:30px;font-size: 12px;border:1px solid;padding:2px;width:165px; word-break: break-all;word-wrap: break-word;white-space: normal;overflow-wrap: break-word;">{{ items.summary }}</td>
                    <td style="text-align: right; height:30px;font-size: 12px;border:1px solid;padding:2px;width:87px;word-wrap: break-word;white-space: normal;overflow-wrap: break-word;">
                      <span v-if="items.debitAmount">{{ items.debitAmount.toFixed(2) }}</span>
                    </td>
                    <td style="text-align: right;height:30px;font-size: 12px;border:1px solid;padding:2px;width:87px;word-wrap: break-word;white-space: normal;overflow-wrap: break-word;">
                      <span v-if="items.creditAmount">{{ items.creditAmount.toFixed(2) }}</span>
                    </td>  
                    <td style="height:30px;text-align: center;font-size: 12px;border:1px solid;padding:2px;width:35px;word-wrap: break-word;white-space: normal;overflow-wrap: break-word;">{{ items.balanceDirection }}</td>
                    <td style="height:30px;text-align: right;font-size: 12px;border:1px solid;padding:2px;width:87px;word-wrap: break-word;white-space: normal;overflow-wrap: break-word;">
                      <span v-if="items.balance">{{ items.balance.toFixed(2) }}</span>
                    </td>
                </tr>
            </tbody>
          </table>
          <div style="display:flex;justify-content: left;;height:22px;line-height:22px">编制单位：{{ currentAccountSets.companyName }}</div>
        </div>
      </div>
    </div>
  </app-content>
</template>

<script>
import accountbook from "@/api/accountbook";
import {downloadBlob} from "download.js";
import manba from "manba";
import {mapGetters, mapState} from "vuex";
import BooUtil from "@/views/accountbook/bookUtil";
import AccountDateRangeChoose from "@/components/AccountDateRangeChoose";
import {clone, findTree, toArrayTree, toTreeArray} from "xe-utils";
import Qs from "qs";
import setting from "@/api/setting";

const DEFAULT_VALUE = {
  closeOnMask: false,
  fullScreen: false,
  middle: true,
  hasMask: true,
  hasDivider: false,
  hasCloseIcon: true,
  draggable: false
};
export default {
  name: 'DetailedAccounts',
  components: {AccountDateRangeChoose},
  //科目余额跳转明细
  props:{
    subjectIds:String,
    start:String,
    end:String,
    isBalance:Boolean
  },
  data() {
    return {
      outModel: false,
      isReadyOut:true,
      isReadyPrints:true,
      valueRadio:'',
      valueRadioOut:'',
      paramRadio:[{ title: '打印全部科目', key: 'a1'}, { title: '打印顶级科目', key: 'a2' }],
      paramRadioOut:[{ title: '导出全部科目', key: 'a1'}, { title: '导出顶级科目', key: 'a2' }],
      paramsStyle: {
        ...DEFAULT_VALUE
      },
      printModel:false,
      // jxd原生连续打印
      printAcc: {
        id: "printMe", // 这里是要打印元素的ID
        popTitle: "&nbsp", // 打印的标题
        // extraCss: "", // 打印可引入外部的一个 css 文件
        // extraHead: "", // 打印头部文字
        // preview: true, // 是否启动预览模式，默认是false
        // previewTitle: '打印客户账单', // 打印预览的标题
        // previewPrintBtnLabel: '预览结束，开始打印', // 打印预览的标题下方的按钮文本，点击可进入打印
        // zIndex: 10002, // 预览窗口的z-index，默认是20002，最好比默认值更高
        previewBeforeOpenCallback () { console.log('正在加载预览窗口！'); }, // 预览窗口打开之前的callback
        previewOpenCallback () { console.log('已经加载完预览窗口，预览打开了！') }, // 预览窗口打开时的callback
        beforeOpenCallback () { console.log('开始打印之前！') }, // 开始打印之前的callback
        openCallback () { console.log('执行打印了！') }, // 调用打印时的callback
        closeCallback () { console.log('关闭了打印工具！') }, // 关闭打印的callback(无法区分确认or取消)
        clickMounted () { console.log('点击v-print绑定的按钮了！') },
      },
      allDataDate:"",//jxd连续打印判断期间
      allData:[],//jxd原生连续打印数组
      //vxe-table打印配置jxd，用于单项打印
      tablePrint: {
        // 自定义打印的样式示例
        style: `
          /* 整个表格的基础样式 */
          .vxe-table {
            font-family: "Microsoft YaHei", 微软雅黑, "MicrosoftJhengHei", 华文细黑, STHeiti, MingLiu; // 设置表格整体字体
          }

          /* 表头单元格 */
          .vxe-table thead th {
            border: 1px solid #000;
            font-size: 14px;
            word-break: break-all;
            overflow-wrap: break-word;
          }

          /* 表体单元格（即数据行的所有单元格） */
          .vxe-body--column, 
          .vxe-table tbody td {
            border: 1px solid #000;
            font-size: 12px;
            word-break: break-all;
            overflow-wrap: break-word;
          }
        `,
        beforePrintMethod: ({ content }) => {
          const headerHtml = `<h3>${this.subject.name} 明细账</h3>
            <div style="display:flex;justify-content: space-between;height:22px;line-height:22px">
                <span>科目：${this.subject ? this.subject.name : ''}</span>
                <span> ${this.title} </span>
                <span> 单位：元 </span>
            </div>
          `;
          const footerHtml = `<div style="display:flex;justify-content: left;;height:22px;line-height:22px">编制单位：${this.currentAccountSets.companyName}</div>`;
          return `${headerHtml}${content}${footerHtml}`;
        },
      },
      loading: false,
      cloneParams: {},
      subjectList: [],
      params: {
        start: null,
        end: null,
        currencyId: null,
        levelStart: 1,
        levelEnd: 4,
        subjectStart: null,
        subjectEnd: null,
      },
      param: {
        keyName: 'id',
        parentName: 'parentId',
        titleName: 'name',
        dataMode: 'list',
        datas: []
      },
      datalist: [],
      subjectId: null,
      showNumPrice: false,
      numPriceDisabled: true,
      accountDate: null,
      subject: null,
      after:{
        subjectStart: null,
        subjectEnd: null,
      }
    };
  },
  computed: {
    ...mapState(['currentAccountSets']),
    ...mapGetters(['checkoutSelect', 'localCurrency']),
    title() {
      if (!this.params.start) {
        return '';
      }
      if (this.params.start === this.params.end) {
        return manba(this.params.start).format("YYYY年MM期")
      }
      return manba(this.params.start).format("YYYY年MM期") + " - " + manba(this.params.end).format("YYYY年MM期");
    }
  },
  watch: {
    subject() {
      let org = this.showNumPrice;
      if (this.subject.unit) {
        this.numPriceDisabled = false;
        //jxd取消普通明细账数量显示
        this.showNumPrice = false;
      } else {
        this.showNumPrice = false;
      }
      this.loadList();
    },
    showNumPrice() {
      this.loadList();
    }
  },
  methods: {
    submitQuery(){
      if(this.params.subjectStart || this.params.subjectEnd){
        this.after.subjectStart = this.params.subjectStart
        this.after.subjectEnd = this.params.subjectEnd
        this.loadSubject()
      }else if((!this.params.subjectStart || !this.params.subjectEnd) && (this.after.subjectStart || this.after.subjectEnd)){
        this.after.subjectStart = this.params.subjectStart
        this.after.subjectEnd = this.params.subjectEnd
        this.loadSubject()
      }else{
        this.loadList()
      }
    },
    dateCheck(){
      // 定义开始时间和结束时间
      let startDate = new Date(this.params.start);
      let endDate = new Date(this.params.end);
      if(startDate > endDate){
        this.$Message({
          type:'warn',
          text: `开始时间必须早于或等于结束时间！`
        });
      }
    },
    outStart(){
      console.log("我执行",this.param.datas.length,this.allData.length)
      const utils = new BooUtil(this.$refs.xTable, '\n')
      let header = utils.header;
      let date,code,subject,summary,debitAmount,creditAmount,balanceDirection,balance;
      header.forEach((item, index) => {
        if(item.title == "日期"){
          date = item.id
        }else if(item.title == "凭证字号"){
          code = item.id
        }else if(item.title == "科目"){
          subject = item.id
        }else if(item.title == "摘要"){
          summary = item.id
        }else if(item.title == "借方"){
          debitAmount = item.id
        }else if(item.title == "贷方"){
          creditAmount = item.id
        }else if(item.title == "方向"){
          balanceDirection = item.id
        }else if(item.title == "余额"){
          balance = item.id
        }
      })
      if (this.param.datas.length && this.allData.length) {
        //组装每个dataList
        console.log(this.allData,666666)
        let allDataList = []
        this.allData.forEach((item,index)=>{
          let dataList = []
          item.data.forEach((item2,index2)=>{
            let obj = {
              [date]:item2.voucherDate,
              [code]:(item2.word && item2.code) ? item2.word + "-" + item2.code : '',
              [subject]:item2.subjectName,
              [summary]:item2.summary,
              [debitAmount]:item2.debitAmount,
              [creditAmount]:item2.creditAmount,
              [balanceDirection]:item2.balanceDirection,
              [balance]:item2.balance
            }
            dataList.push(obj)
          })
          let subjectName = dataList[0][subject];
          console.log(subjectName)
          let obj2 = {[subjectName]:dataList}
          allDataList.push(obj2)
        })
        console.log(allDataList,888,this.currentAccountSets)
        // 计算所有行数总和
        let totalCount = 0;

        allDataList.forEach(item => {
            // 获取对象中的第一个（也是唯一一个）键值对
            const key = Object.keys(item)[0];
            console.log(key)
            const array = item[key];
            totalCount += array.length;
        });
        console.log(totalCount)

        if(totalCount > 10000){
          this.$Message({
            type:'warn',
            text: `导出数据量过大，请选择单个科目导出或减少查询时间范围！`
          });
        }else if(totalCount == 0){
          this.$Message({
            type:'warn',
            text: `导出的数据为空，请检查查询条件！`
          });
        }else{
          accountbook.downloads({header: utils.header, dataList: allDataList}).then((data) => {
            downloadBlob(`${this.title}-${this.currentAccountSets.companyName}-批量导出明细账.xls`, data)
          })
        }
      }
    },
    changeRadio(type = ""){
      if(type == 'out'){
        this.isReadyOut = true;
        console.log(111)
      }else{
        this.isReadyPrints = true;
      }
      // console.log(this.valueRadio,this.param.datas,this.allData)
      let km = this.param.datas;
      let allData2 = this.allData;
      // console.log(km);
      let km2 = [];
      let that = this;
      //先根据要打印的科目整理a1全部，a2顶级
      if(this.valueRadio == 'a2' || this.valueRadioOut == 'a2'){
        km.forEach((item,index)=>{
          if(item.parentId == '0'){
            km2.push(item);
          }
        });
        (async () => {
          // 创建一个Set用于存储已有数据项的id或name
          let existingIdsOrNames = new Set(allData2.map(item => item.code));
          let promises = km2.map(async (items, indexs) => {
            let combinedKey = items.code;
            if (!existingIdsOrNames.has(combinedKey)) {
              existingIdsOrNames.add(combinedKey);
              return accountbook.loadVoucherDetails(Object.assign({
                subjectId: items.id,
                showNumPrice: that.showNumPrice,
                subjectCode: items.code
              }, that.params)).then(({ data }) => {
                // console.log(items.name);
                that.conPrint(data); // 临时存储连续打印的数据方法
              });
            }
            return Promise.resolve();
          });
          await Promise.all(promises);
          //过滤掉非顶级
          // console.log(that.allData,that.allData[0].code.length)
          let arr = that.allData.filter(item => item.code.length === 4)
          console.log(arr)
          // console.log(arr)
          that.allData = arr;
          if(type == 'out'){
            that.isReadyOut = false;
            console.log(that.isReadyOut,"666666666666666666666666")
          }else{
            that.isReadyPrints = false;
          }
          // console.log(that.isReadyPrints, that.allData);
        })();
      }else{
        (async () => {
          // 创建一个Set用于存储已有数据项的id或name
          let existingIdsOrNames = new Set(allData2.map(item => item.code));
          let promises = km.map(async (items, indexs) => {
            let combinedKey = items.code;
            // console.log(existingIdsOrNames,items.code)
            if (!existingIdsOrNames.has(combinedKey)) {
              existingIdsOrNames.add(combinedKey);
              return accountbook.loadVoucherDetails(Object.assign({
                subjectId: items.id,
                showNumPrice: that.showNumPrice,
                subjectCode: items.code
              }, that.params)).then(({ data }) => {
                // console.log(items.name);
                that.conPrint(data); // 临时存储连续打印的数据方法
              });
            }
            return Promise.resolve();
          });
          await Promise.all(promises);
          if(type == 'out'){
            that.isReadyOut = false;
            console.log(that.isReadyOut,"666666666666666666666666")
          }else{
            that.isReadyPrints = false;
          }
          // console.log(that.isReadyPrints, that.allData);
        })();
      }
    },
    //查询时间变更，置空临时存储的数据jxd
    changeStart(){
      this.dateCheck();
      this.allDataDate = "";
      this.allData = [];
    },
    changeEnd(){
      this.dateCheck();
      this.allDataDate = "";
      this.allData = [];
    },
    loadSubject() {
      this.datalist = [];
      accountbook.loadSubject(this.params).then(({data}) => {
        this.param.datas = data;
        // console.log(this.param)
        if (data.length) {
          this.subjectId = data[0].id;
          this.subject = data[0];
        } else {
          this.datalist = [];
        }
      });
    },
    sfilter(item, val) {
      return item.code.indexOf(val) !== -1 || item.name.indexOf(val) !== -1 || item.mnemonicCode.indexOf(val) !== -1;
    },
    loadList() {
      //科目余额跳转明细
      if(this.subjectIds){
        this.subject = this.subjectList.find(item => item.id === this.subjectIds);
        this.loading = true;
        this.params.start = this.start;
        this.params.end = this.end;
        accountbook.loadVoucherDetails(Object.assign({
          subjectId: this.subjectIds,
          showNumPrice: this.showNumPrice,
          subjectCode: this.subject.code
        }, this.params)).then(({data}) => {
          this.conPrint(data);//临时存储连续打印的数据方法
          this.datalist = data;
          this.$refs.paramsDropdown.hide()
        }).finally(() => this.loading = false);
      }else if (this.subjectId) {
        this.loading = true;
        accountbook.loadVoucherDetails(Object.assign({
          subjectId: this.subjectId,
          showNumPrice: this.showNumPrice,
          subjectCode: this.subject.code
        }, this.params)).then(({data}) => {
          this.conPrint(data);//临时存储连续打印的数据方法
          this.datalist = data;
          this.$refs.paramsDropdown.hide()
        }).finally(() => this.loading = false);
      }
    },
    //存储连续打印的科目数据处理
    conPrint(data){
      //jxd临时存储查询过的报表，如用户进行连续打印，条件不变的情况下可以直接打印
      // console.log(this.title)
      this.allDataDate = this.allDataDate ? this.allDataDate : this.title;
      const regex = new RegExp("^\\d+");
      const match = data[0].subjectName.match(regex);
      // if (match) {
      //   // console.log(match[0]); // 输出：1131
      // }
      let obj = {date:this.title,name:data[0].subjectName,id:data[1].subjectId,code:match[0],data:data}
      let res =  this.allData.find(account => {
        return account.name === obj.name && account.date === obj.date;
      });
      if(res == undefined){
        //这个记录缓存中没有，存进去
        this.allData.push(obj)
        console.log("不存在")
      }else{
        //有这个记录，不存了
        console.log("存在")
      }
      // console.log(this.allData)
    },
    subjectSelect(node) {
      this.subject = node;
    },
    exportData() {
      if (this.param.datas.length) {
        const utils = new BooUtil(this.$refs.xTable, '\n')
        accountbook.download({header: utils.header, dataList: utils.dataList}).then((data) => {
          downloadBlob(`${this.subject.name}-${this.title}-明细账.xls`, data)
        })
      }else if (this.isBalance){
        const utils = new BooUtil(this.$refs.xTable, '\n')
        accountbook.download({header: utils.header, dataList: utils.dataList}).then((data) => {
          downloadBlob(`${this.subject.name}-${this.title}-明细账.xls`, data)
        })
      }
    },
    printData() {
      // 获取VXE-Table实例
      const xTable = this.$refs.xTable;
      // 调用打印方法，并传入打印配置
      xTable.print({
        // 使用上面定义的全局tablePrint配置
        // 同时可以在此处覆盖任何特定于本次打印的配置
        ...this.tablePrint,
        // 如果需要在这里临时指定打印列，可以这样配置
        // columns: columnsToPrint.map(column => ({
        //   field: column.property,
        // })),
      });
      // this.$refs.xTable.print()
    },
    resetForm() {
      this.params = clone(this.cloneParams, true)
    }
  },
  created() {
    this.params.start = manba(this.currentAccountSets.currentAccountDate).format("YYYY-M");
    this.params.end = this.params.start;
    this.params.currencyId = this.localCurrency.id;
    this.cloneParams = clone(this.params, true)

    //jxd这里的科目选择应该是所有科目
    setting.subject.listAll().then(({data}) => {
      this.subjectList = data;
      if(!(this.subjectIds && this.start && this.end)){
        this.loadSubject();
      }else{
        this.loadList();
      }
    })
  }
};
</script>
<style scoped>

/* jxd希望通过css处理页码，但是纸张不同没法处理 */
/* @media print {
  @page {
    margin: 10mm 16mm;
    margin-bottom: 8mm;
    margin-top:8mm
  }
} */
/* 当子科目过多的时候，10000px的高度完全不够用，改为60000px，其他的明细账暂时先不改 */
:deep(.h-tree-li-opened > .h-tree-ul) {
  max-height:60000px;
  transition: max-height 2s ease-in-out;
}

</style>